// extracted by mini-css-extract-plugin
export default {"tab":"Tabs_tab__zKft6","isSelected":"Tabs_isSelected__S5-1s"};